<template>
  <Tooltip>
    <template #reference>
      <div :style="styles" class="color-ball" />
    </template>
    <p>{{ props.name }}</p>
  </Tooltip>
</template>

<script setup>
const props = defineProps({
  name: {
    required: true,
    type: String,
  },
  colors: {
    required: true,
    type: Array,
  },
  size: {
    type: Number,
    default: 30,
  },
});

const styles = computed(() => {
  const styles = {
    borderRadius: `${props.size}px`,
    height: `${props.size}px`,
    width: `${props.size}px`,
  };

  if (props.colors.filter((e) => typeof e !== "undefined").length === 1) {
    styles.background = props.colors[0];
  } else {
    styles.background = `linear-gradient( ${props.colors[0]} 50%, ${props.colors[1]} 50%)`;
  }

  return styles;
});

defineComponent({
  inheritAttrs: true,
});
</script>

<style lang="postcss">
.color-ball {
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.8);
  position: relative;
  &::after {
    content: " ";
    position: absolute;
    z-index: -1;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border: 5px solid #ffea00;
  }
}
</style>
